import { Input, SearchIcon, Select } from "@jutro/ui";
import { SetStateAction } from "jotai";
import { Dispatch } from "react";
import {
  StaffGenreFilter,
  staffGenreFilterOptions,
} from "views/StaffSchedule/tools";

type Props = {
  selectedStaffGenre: StaffGenreFilter;
  searchInputValue: string;
  setSelectedStaffGenre: Dispatch<SetStateAction<StaffGenreFilter>>;
  setSearchInputValue: Dispatch<SetStateAction<string>>;
};

export const StaffFilters = ({
  selectedStaffGenre,
  searchInputValue,
  setSelectedStaffGenre,
  setSearchInputValue,
}: Props) => {
  return (
    <div className="flex gap-4">
      <div className="w-72">
        <Select
          value={
            staffGenreFilterOptions.find(
              ({ value }) => value === selectedStaffGenre,
            ) ?? null
          }
          options={staffGenreFilterOptions}
          onChange={(e) => {
            if (!e) {
              return;
            }

            const option = staffGenreFilterOptions.find(
              (option) => option.value === e.value,
            );

            if (!option) {
              return;
            }

            setSelectedStaffGenre(option.value);
          }}
        />
      </div>
      <div className="w-72">
        <Input
          placeholder="Szukaj..."
          maxLength={20}
          sideElement={<SearchIcon size="sm" />}
          sideElementPosition="start"
          value={searchInputValue}
          onChange={(e) => {
            setSearchInputValue(e.target.value.trim());
          }}
        />
      </div>
    </div>
  );
};
